module.exports = __webpack_public_path__ + "static/media/image-card-1.0a02a89f.png";